import axios from './axiosInstance';

export default {
  // Activate Project
  activateProject(activationData) {
    return axios.post('/activations/', activationData);
  },

  // Reset Activation
  resetActivation(activationData) {
    return axios.post('/activations/reset', activationData);
  },

  // Delete Project
  deleteProject(projectId) {
    return axios.delete(`/activations/${projectId}`);
  },

  // Deactivate Project
  deactivateProject(projectId) {
    return axios.delete(`/activations/deactivate/${projectId}`);
  },

  // Search Activations
  searchActivations(query, page = 1, size = 10) {
    return axios.get('/activations/projects/search', {
      params: { query, page, size },
    });
  },

  // Get Activations
  getActivations(params) {
    return axios.get('/activations/projects', {
      params: params,
    });
  },

  getActivation(projectId) {
    return axios.get(`/activations/${projectId}`);
  },

  // Get Unassigned Phone Numbers
  getUnassignedPhoneNumbers(page = 1, size = 10) {
    return axios.get('/activations/available_phone_numbers', {
      params: { page, size },
    });
  },

  // Get Unassigned Emails
  getUnassignedEmails(page = 1, size = 10) {
    return axios.get('/activations/available_emails', {
      params: { page, size },
    });
  },
  wipeDatabase() {
    // POST /activations/wipe_db
    return axios.post("/activations/wipe_db");
  },
};
